export default __webpack_public_path__ + "static/media/dongho_big.fe3387fc.png";